import { AuthenticationService } from './authentication-service-model';

export class UserLoginType {
    authenticationService: AuthenticationService = AuthenticationService.Local;
    ssoId: string | null = null;
}